import React, { FC } from 'react';
import cn from 'classnames';

interface Props {
  isHelper?: boolean;
  isError?: boolean;
  isWarning?: boolean;
  message: string;
}

const FootNote: FC<Props> = ({
  isHelper = true,
  isWarning,
  isError,
  message
}) => {
  const mergedClassName = cn(
    'fs-caption-reg pt-1',
    isHelper && 'text-black opacity-75',
    isError && 'text-scarlet',
    isWarning && 'text-pizazz'
  );

  return <div className={mergedClassName}>{message}</div>;
};

export default FootNote;
